<template>

<div>
  <div class="header-container pb-2">
    <h2>Gestión de Operarios</h2>
    <form class="filter-form">
      <div class="form-group">
        <label>Nombre y Apellidos
          <b-form-input v-model="filters.name"/>
        </label>
      </div>
      <div class="form-group">
        <label>Estado
          <b-form-select v-model="filters.status" :options="statusOptions"/>
        </label>
      </div>
      <div>
        <b-button @click="filterUsers" variant="primary">Buscar</b-button>
      </div>
    </form>
    <div class="d-flex justify-content-center">
      <b-pagination class="ml-auto" v-model.number="paginator.page" @change="onPageChange"
                    :per-page="paginator.perPage" :total-rows="paginator.totalElements"/>
      <div class="pr-4 ml-auto">
        <div class="d-flex justify-content-center">
          <b-button :disabled="!canCreate" @click="$refs.addModal.show()" variant="success">Nuevo Usuario</b-button>
        </div>
        <div class="d-flex justify-content-center">
          <a target="_blank" href='/static/roles_usuario.pdf'>Lee aquí la guía sobre los roles de usuario</a>
        </div>
      </div>
    </div>
  </div>
  <div class="fixed-table-container">
    <b-table striped :items="paginator.content" :fields="fields" no-local-sorting @sort-changed="sortUsers">
      <template slot="buttons" slot-scope="data">
        <b-button :disabled="!canUpdate" @click="openEditModal(data.item)" size="sm" variant="primary"><fa-icon icon="edit"/></b-button>
        <b-button :disabled="!canDelete" @click="deleteOperario(data.item)" variant="danger" size="sm"><fa-icon icon="trash-alt"/></b-button>
      </template>
    </b-table>
  </div>
  <add-user-modal ref="addModal" @save="createUser"/>
  <edit-user-modal ref="editModal" :initial-user="selectedUser" @save="updateUser"/>
  <b-modal ref="deleteDialog" title="¿Está Seguro?" ok-title="Eliminar" cancel-title="Cancelar"
           ok-variant="danger" header-bg-variant="danger" header-text-variant="light">
    <p>¿Está seguro de que desea eliminar el operario?</p>
  </b-modal>
</div>

</template>

<script>

import api from '@/api/api'
import AddUserModal from './AddUserModal'
import EditUserModal from './EditUserModal'
import {session} from '@/auth'

export default {
  name: 'UserIndex',
  components: {
    AddUserModal,
    EditUserModal
  },
  created() {
    this.loadUsers(1)
  },
  data() {
    return {
      session,
      selectedUser: null,
      paginator: {
        page: 1,
        perPage: 10,
        totalElements: 0,
        content: []
      },
      sort: null,
      fields: [
        {key: 'name', label: 'Nombre y Apellidos', sortable: true},
        {key: 'email', label: 'Correo electrónico', sortable: true},
        {key: 'appUserType', label: 'Rol', sortable: true, formatter: v => this.getAppUserTypeLabel(v)},
        {key: 'status', label: 'Estado', sortable: true, formatter: v => this.getStatusLabel(v)},
        {key: 'buttons', label: 'Gestión'}
      ],
      filters: {
        name: null,
        status: null
      },
      statusOptions: [
        {text: 'Todos', value: null},
        {text: 'Activado', value: 'ACTIVATED'},
        {text: 'Desactivado', value: 'DEACTIVATED'}
      ],
      appUserTypeOptions: [
        {text: 'Operario', value: 'EMPLOYEE'},
        {text: 'Gestor', value: 'MANAGER'},
        {text: 'Administrador', value: 'ADMINISTRATOR'}
      ]
    }
  },
  computed: {
    canCreate() {
      return this.session.authorities.includes('ROLE_USER_CREATE')
    },
    canUpdate() {
      return this.session.authorities.includes('ROLE_USER_UPDATE')
    },
    canDelete() {
      return this.session.authorities.includes('ROLE_USER_DELETE')
    }
  },
  methods: {
    getStatusLabel(value) {
      return value && (this.statusOptions.find((i) => i.value === value).text || null)
    },
    getAppUserTypeLabel(value) {
      return value && (this.appUserTypeOptions.find((i) => i.value === value).text || null)
    },
    openEditModal(user) {
      this.selectedUser = user
      this.$refs.editModal.show()
    },
    onPageChange(page) {
      this.loadUsers(page)
    },
    filterUsers() {
      this.loadUsers(1)
    },
    sortUsers(context) {
      this.sort = context.sortBy && context.sortBy + ',' + (context.sortDesc ? 'desc' : 'asc')
      this.loadUsers(1)
    },
    loadUsers(page = this.paginator.page) {
      const params = {page: page - 1, size: this.paginator.perPage, sort: this.sort, ...this.filters}
      api.appUser.index(params).then(paginator => {
        this.paginator.content = paginator.content
        this.paginator.totalElements = paginator.totalElements
        this.paginator.page = page
      })
    },
    createUser(user) {
      api.appUser.create(user).then(() => {
        this.loadUsers(1)
        this.$toastr('success', 'Usuario Creado')
      })
    },
    updateUser(user) {
      api.appUser.update(user).then(() => {
        this.loadUsers()
        this.$toastr('success', 'Usuario Editado')
      })
    },
    deleteOperario(operario) {
      this.$refs.deleteDialog.$off('ok') // very important. clear previous custom event listeners
      this.$refs.deleteDialog.$once('ok', () => {
        api.appUser.delete(operario.id).then(() => {
          this.loadUsers().then(() => this.$toastr('success', 'Operario Eliminado'))
        })
      })
      this.$refs.deleteDialog.show()
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/user/Index.vue